import LibraryMobi from "./Library-Mobile/LibraryMobi";
import LibraryBanner from "./Library-Banner/LibraryBanner";
import LibraryPc from "./LibraryPc/LibraryPc";
import Contact from "../Contact/Contact";

export default function LibraryImage() {
  return (
    <div className="w-full pt-24">
      <LibraryBanner />
      <div className="w-full block md:hidden lg:hidden">
        <LibraryMobi />
      </div>
      <div className="w-full hidden md:block lg:block">
        <LibraryPc />
      </div>

      <Contact />
    </div>
  );
}
